import type { HrmsType } from "@/redux/hrms/hrmsTypes";

import { RECRUITMENT_TRACKER_TABS } from "@/constant/hrms/recruitmentModule/recruiterModuleConst";

export const initialListSorting = {
  name: "",
  value: "",
  _id: "",
  id: "",
};

export const initialScroll = {
  top: 0,
  restoreOnce: false,
};

export const createFilterState = () => ({
  startDate: "",
  endDate: "",
  location: { label: "", value: "" },
  recruiter: { label: "", value: "" },
  progress: { label: "", value: "" },
  gender: { label: "", value: "" },
  openPosition: { label: "", value: "" },
  experience: null as number | null,
});

export const initialListFilters = {
  applied: createFilterState(),
  draft: createFilterState(),
};

export const initialState: HrmsType = {
  success: null,
  error: null,
  statusCode: null,
  message: "",
  fetching: false,
  openPoisitionList: [],
  openPositionTotalCount: 0,
  recruitmentTrackerList: [],
  recruitmentTrackerTotalCount: 0,
  singleRecruitmentTrackerList: null,
  uniqueCheckFetching: false,
  uniqueCheckMessage: "",
  addEditFetching: false,
  approvalList: [],
  approvalTotalCount: 0,
  recruitmentTrackerStageCount: [],
  hrmsBulkUploadData: {},
  bulkUploadHistoryData: [],
  bulkUploadHistoryCount: 0,
  resignationListData: [],
  resignationListTotalCount: 0,
  weightedAverageReportList: [],
  weightedAverageReportTotalCount: 0,
  scroll: initialScroll,
  recruitmentListUI: {
    sortBy: initialListSorting,
    filters: initialListFilters,
    searchTerm: "",
  },
  activeRecruitmentTab: RECRUITMENT_TRACKER_TABS[0]?.label,
};
